<script setup lang="ts">
// @ts-ignore
import i18n from '@/localization/i18n';
import Link from '@/views/components/Link.vue'
import { defineAsyncComponent, onBeforeUnmount, onMounted, Ref, ref } from 'vue'
import { useAlertsStore } from '@/stores/alerts';
import TopelaDesktopLogo from '@/views/components/TopelaDesktopLogo.vue';

const Lock = defineAsyncComponent(() => import('vue-material-design-icons/Lock.vue'))

// Local variables
const t = i18n.global.t

// @ts-ignore
const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL

const isMobile = ref(false)
const hasOpenApp = ref(false)
const storeRedirectTimeout: Ref<any | null> = ref(null)

// Lifecycle hooks
onMounted(() => {
    isMobile.value = isMobileDevice()
    handleResize()
    window.addEventListener('resize', handleResize);
})

function isMobileDevice() {
    return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
}

function openTopelaApp() {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes('android')) {
        const appLink = 'topelaapp://topela';
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        hasOpenApp.value = true
        iframe.src = appLink;
        document.body.appendChild(iframe);

        storeRedirectTimeout.value = setTimeout(() => {
            hasOpenApp.value = false
            window.open(
                t("g_txt_topela_play_store_link"), '_blank'
            );
        }, 1500);

        // Set up event listeners for blur/focus within this function
        window.onblur = () => {
            // App likely opened
            clearTimeout(storeRedirectTimeout.value);
        };

        window.onfocus = () => {
            if (storeRedirectTimeout.value) {
                // Clear if coming back
                clearTimeout(storeRedirectTimeout.value);
                storeRedirectTimeout.value = null;

                if (hasOpenApp.value) {
                    const alerts = useAlertsStore()
                    alerts.putAlert({ 'code': 'backFromAppSuccess', 'scope': 'general' })
                    hasOpenApp.value = false
                }
            }
        };
    } else {
        window.open(
            '/ps/home/', '_blank'
        );
    }
    /*else if (userAgent.includes('iphone') || userAgent.includes('ipad')) {
        const appLink = 'topelaapp://topela';
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        hasOpenApp.value = true
        iframe.src = appLink;
        document.body.appendChild(iframe);

        storeRedirectTimeout.value = setTimeout(() => {
            hasOpenApp.value = false
            window.open(
                t("g_txt_topela_app_store_link"), '_blank'
            );
        }, 1500);

        // Set up event listeners for blur/focus within this function
        window.onblur = () => {
            // App likely opened
            clearTimeout(storeRedirectTimeout.value); 
        };

        window.onfocus = () => {
            if (storeRedirectTimeout.value) {
                // Clear if coming back
                clearTimeout(storeRedirectTimeout.value);
                storeRedirectTimeout.value = null;

                if(hasOpenApp.value){
                    const alerts = useAlertsStore()
                    alerts.putAlert({ 'code': 'backFromAppSuccess', 'scope': 'general' })
                    hasOpenApp.value = false
                }
            }
        };
        // window.open(
        //     t("g_txt_topela_app_store_link"), '_blank'
        // );
    }*/
}

function openProSpace() {
    window.open(
        '/ps/home/', '_blank'
    );
}

onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize);
});

const handleResize = () => {
    isMobile.value = isMobileDevice()
};
</script>

<template>
    <!-- Header Section Start -->
    <div class="">
        <nav id="header-public"
            class="navbar navbar-expand-md bg-inverse position-fixed top-0 start-0 scrolling-navbar mt-4 mt-md-3 bg-white bg-dark-blue">
            <div class="container ">
                <template v-if="isMobile">
                    <Link href="/" class="navbar-brand">
                    <img width="50px" :src="VITE_ASSET_URL + 'assets/logo/logos_Topela_Phone.svg'" alt="Logo topela">
                    </Link>
                </template>
                <template v-else>
                    <Link href="/" class="navbar-brand mx-0 d-none d-md-block">
                    <TopelaDesktopLogo :styleStr="'position: relative; left:-6.5px'" />
                    </Link>
                    <Link href="/" class="navbar-brand mx-0 d-block d-md-none">
                    <img width="50px" :src="VITE_ASSET_URL + 'assets/logo/logos_Topela_Phone.svg'" alt="Logo topela">
                    </Link>
                </template>

                <ul class="navbar-nav ms-auto d-flex align-items-center">
                    <li class="nav-item">
                        <button type="button" class="btn btn-primary py-2 px-3 rounded d-flex flex-row align-items-center gap-2"
                            @click="isMobile ? openTopelaApp() : openProSpace()"
                            :aria-label="t('w_txt_pro_access_professional_space')">
                            <span class="material-symbols-outlined">lock</span>
                            <span>{{ t('w_fct_header_workerSpace') }}</span>
                        </button>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
    <!-- Header Section End -->
</template>

<style scoped>
@import url('@/assets/css/bootstrap-extended.css');
@import url('@/assets/css/animate.css');
@import url('@/assets/css/main.css');
@import url('@/assets/css/responsive.css');

.secondary-btn {
    background-color: #49AFDA !important;
    color: white;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: 14px;
    border: none;
    font-weight: bold !important;
}

.navbar {
    right: 0px;
    z-index: 900;
}

.ms-2 {
    margin-left: 2rem !important;
}

.btn-primary {
    /* background-color: #49AFDA !important; */
    background-color: #233648 !important;
    color: white !important;
    border: 1px solid white !important;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 15px;
    font-weight: normal !important;
    font-size: 20px !important
}

.btn-primary:hover {
    background-color: white !important;
    border: 1px solid #233648 !important;
    color: #233648 !important;
   
    box-shadow: 0px 8px 9px 0px rgba(96, 94, 94, 0.17) !important;
}


.text-light {
    font-size: 10px;
}

/* Adjust the positioning and spacing */
.d-flex.align-items-center {
    gap: 10px;
}

.form-control::placeholder {
    font-size: 0.9rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .d-flex.align-items-center {
        flex-direction: column;
        align-items: flex-start;
    }

    .btn-primary {
        margin-top: 8px;
    }
}

@media only screen and (min-width: 600px) {
    .navbar {
        /* right: 17px; */
        right: 1vw;
        width: 99vw;
        z-index: 900;
    }
}

@media screen and (max-width: 786px) {
    .navbar-nav {
        margin-top: 20px !important;
    }

    .btn-primary {
        font-size: 16px !important;
        display: flex;
        align-items: center;
    }

}
.bg-dark-blue {
    background-color: #233648 !important;
}
</style>